export default "__VITE_ASSET__8TGaAbFF__"